"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));
var _react = _interopRequireWildcard3(require("react"));
var Lazy = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2["default"])(require('./sync/VisibleIcon'));
  })["catch"](function (error) {
    console.log('[APP] Component Failed Loading:', error);
    return {
      "default": function _default() {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }
    };
  });
});
var _default2 = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement("div", null)
  }, /*#__PURE__*/_react["default"].createElement(Lazy, Object.assign({}, props, {
    ref: ref
  })));
});